<script lang="ts" setup>
import { computed, ref, useSlots, PropType, defineEmits } from "vue";

const props = defineProps({
  /**
   * Значение
   */
  modelValue: { type: Boolean as PropType<boolean | null>, default: null },
  /**
   * Варинант
   */
  isUnselect: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Дизейбл
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Подсказка ошибки
   */
  isError: { type: Boolean as PropType<boolean>, default: false },
});
/**
 * События
 */
const emit = defineEmits<{
  (eventName: "update:modelValue", value: boolean): void;
  (eventName: "check", value: boolean): void;
}>();
/**
 * Внутреннее значение
 */
const innerValue = ref(false);

const slots = useSlots();

/**
 * Есть ли слот для лейбла текста
 */
const isWithLabel = computed(() => slots && slots.mainSign && slots.mainSign());
const isWithHintSign = computed(() => slots && slots.hintSign && slots.hintSign());
/**
 * Значение
 */
const value = computed({
  get: () => (props.modelValue == null ? innerValue.value : props.modelValue),
  set: (value: boolean) => {
    emit("update:modelValue", value);
    innerValue.value = value;
    emit("check", value);
  },
});

/**
 * При клике
 */

const onCheck = () => {
  if (props.isDisabled) return;
  value.value = !value.value;
};
</script>

<template>
  <div class="checkbox" :class="{ 'checkbox--disabled': isDisabled }" @click="onCheck">
    <div class="checkbox__wrapper">
      <div
        class="checkbox__inner-icon"
        :class="{ 'checkbox__inner-icon--check': value}"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="8"
          viewBox="0 0 10 8"
          fill="none"
          v-if="!props.isUnselect"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 1.5L3.5 8L1.09122e-08 4.5L1.5 3L3.5 5L8.5 -2.06119e-08L10 1.5Z"
            fill="currentColor"
          />
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="2"
          viewBox="0 0 10 2"
          fill="none"
          v-if="props.isUnselect"
        >
          <path d="M0 0H10V2H0V0Z" fill="currentColor" />
        </svg>
      </div>
    </div>
    <div class="checkbox__signs" v-if="isWithLabel">
      <span class="checkbox__main-sign">
        <slot name="mainSign"></slot>
      </span>
      <span
        class="checkbox__hint-sign"
        v-if="isWithHintSign"
        :class="{
          'checkbox__hint-sign--error': props.isError,
        }"
      >
        <slot name="hintSign"></slot>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>
